export class OptionMenuController {

    constructor($log, $timeout) {
        'ngInject';

        this.$log = $log;
        this.$timeout = $timeout;
        this.active = true;

    }

    selectOption(optionSet, option) {

        this.$log.debug('OptionMenuController::selectOption', option);

        optionSet.selectedOption = option;

        if (this.active) this.onOptionSelected({option: option});

        this.active = false;

        this.$timeout(() => {
            this.active = true;
        }, 1000);

    }

}



// WEBPACK FOOTER //
// ./src/js/components/option-menu/option-menu.controller.js